/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './TopBar.style';

type Props = {
  children: React.Node,
};

const useStyles = createUseStyles(styles);

const TopBar = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */
  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return <div className={classes.root}>{children}</div>;
};

export default compose(React.memo)(TopBar);
